import '@/assets/styles/element-variables.scss';
import Element, {Message} from 'element-ui';
// @ts-ignore
import Cookies from 'js-cookie';

import Vue from 'vue';
// @ts-ignore
window.ELEMENT = Element;
Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
});

export function msgSuccess(msg = '') {
  Message({showClose: true, message: msg, type: 'success'});
}

Vue.prototype.msgSuccess = msgSuccess;

Vue.prototype.msgError = function(msg = '') {
  Message({showClose: true, message: msg, type: 'error'});
};

Vue.prototype.msgInfo = function(msg = '') {
  Message.info(msg);
};
